export default "__VITE_ASSET__DiYvzVeP__"